﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

//No internet
require('typeahead-addresspicker');

import tpl_forgotPassword from './tpl/forgotPassword.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';

import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import View_DialogBox from '../../../lib/views/dialogBox/dialogBox';

import config from '../../../common/config';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import * as Entities_PublicRecaptchaForgotPassword from '../../entities/publicRecaptchaForgotPassword';  

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_forgotPassword({ model: this.model.toJSON() });
    },
    initialize: function () {
        var self = this;
        this.app = this.options.app;

        this.model.attributes.Email = '';
        this.model.attributes.Password = '';
    },
    regions: {
    },
    onBeforeShow: function () {
    },
    ui: {
        'forgotPassword_inputEmail' : '#forgotPassword_inputEmail',
        'forgotPassword_btnSubmit' : '#forgotPassword_btnSubmit',
        'forgotPassword_p_verifyOK' : '#forgotPassword_p_verifyOK',
        'recaptcha_container' : '#recaptcha_container'
    },
    events: {
        'click @ui.forgotPassword_btnSubmit': 'forgotPassword_btnSubmitClick'
    },
    onRender: function () {
    },
    onAttach(){
    },
    clearView : function() {
        this.app.router.forgotPassword();
    },
    loadCaptcha: function() {
        var self = this;

        var getRecaptchaResponse = function(response) {

            var data = {
                response: response
            }

            self.model.attributes.response = response;

            self.model.save(self.model.attributes, {
                route : 'forgotPassword',
                silent: true,
                wait:true,
                //dataType: 'text',
                success: function success() {
                    var dialogBoxModel = new Entities_Empty.Model();
                    dialogBoxModel.attributes.Title = resources.X200023;
                    dialogBoxModel.attributes.Text = resources.X200024;
                    dialogBoxModel.attributes.Button = resources.X200025;

                    var dialogBox = new View_DialogBox({ model: dialogBoxModel, parent: self });
                    var callback2 = function () {
                        self.stopListening(dialogBox, "dialog:okclicked", callback2);

                        self.clearView();
                    }
                    self.listenTo(dialogBox, "dialog:okclicked", callback2);
                    self.app.dialogRegion.show(dialogBox);
                },
                error: function error() {
                    alert("Error");
                }
            });
        };

        var renderCaptcha = function() {
            self.captchaWidgetId = grecaptcha.render('recaptcha_container', {
                sitekey : config.googleRecaptchaSiteKey(),
                callback: getRecaptchaResponse,
                text : 'sseat'
            });

            
        };

        window.renderCaptcha = renderCaptcha;

        $.getScript('https://www.google.com/recaptcha/api.js?onload=renderCaptcha&render=explicit', function() { });
    },
    forgotPassword_btnSubmitClick: function (event) {
        var self = this;
        this.hideErrors();

        if (this.setModel()) {

            var callback = function (ret) {
                if (ret == true) {
                    self.loadCaptcha();
                    self.ui.forgotPassword_p_verifyOK.show();
                    self.ui.forgotPassword_btnSubmit.css('display', 'none');
                } else  {
                    self.showErrors(self.model.errors);
                    $('html,body').scrollTop(0);
                } 
            }
            this.model.validateNoBackbone(this.model.attributes, this.app, callback);
        }
    },
    setModel: function (parsedGeocodeResult) {
        this.hideErrors();
        this.model.set({
            Email: this.ui.forgotPassword_inputEmail.val(),
            EmailFrom: resources.X200026,
            Subject: resources.X200027,
            Body: resources.X200028
        });

        return true;
    },
    save: function () {
        var self = this;
        this.hideErrors();

        var callback = function (ret) {
            if (ret == true) {
                var dialogWaitingModel = new Entities_Empty.Model();
                dialogWaitingModel.attributes.Title = resources.X200020;
                dialogWaitingModel.attributes.Text = resources.X200020;
                dialogWaitingModel.attributes.Button = resources.X200025;

                var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: self });
                var callback = function (options) {
                    self.stopListening(dialogWaiting, "dialog:okclicked", callback);
                }
                self.listenTo(dialogWaiting, "dialog:okclicked", callback);
                self.app.dialogRegion.show(dialogWaiting);

        
                self.model.save(self.model.attributes, {
                    success: function () {
                        dialogWaiting.triggerMethod('dialog:close');

                        var dialogBoxModel = new Entities_Empty.Model();
                        dialogBoxModel.attributes.Title = resources.X200020;
                        dialogBoxModel.attributes.Text = resources.X200029;
                        dialogBoxModel.attributes.Button = resources.X200025;

                        var dialogBox = new View_DialogBox({ model: dialogBoxModel, parent: self });
                        var callback01 = function (options) {
                            this.stopListening(dialogBox, "dialog:okclicked", callback01);

                            //self.model.trigger('change');
                            self.clearView();
                        }
                        self.listenTo(dialogBox, "dialog:okclicked", callback01);
                        self.app.regions.dialog.show(dialogBox);
                    },
                    error: function () {
                        dialogWaiting.triggerMethod('dialog:close');

                        var dialogBoxModel = new Entities_Empty.Model();
                        dialogBoxModel.attributes.Title = resources.X100901;
                        dialogBoxModel.attributes.Text = resources.X100684;
                        dialogBoxModel.attributes.Button = resources.X100279;

                        var dialogBox = new View_DialogBox({ model: dialogBoxModel, parent: self });
                        var callback02 = function (options) {
                            this.stopListening(dialogBox, "dialog:okclicked", callback02);
                        }
                        self.listenTo(dialogBox, "dialog:okclicked", callback02);
                        self.app.regions.dialog.show(dialogBox);
                    }
                });
            } else  {
                self.showErrors(self.model.errors);
                $('html,body').scrollTop(0);
            } 
        }

        this.model.validateNoBackbone(this.model.attributes, this.app, callback);
    }
    
}, Backbone.Radio.Requests);
